import axios from "../../../utils/axios";
import { handleRemoveEmptyParamFromQueryParams } from "../../../utils/helpers";
import {
    IAddPaymentCardPayload,
    IBillsFilters,
    IChargePaymentCardPayload,
} from "../types/billing.types";

export async function getOutstandingBills(filters: IBillsFilters) {
    const response = await axios.get(`/bills`, {
        params: handleRemoveEmptyParamFromQueryParams(filters),
    });
    return response.data;
}

export async function fetchPaymentCards() {
    const response = await axios.get(`/payment-cards`);
    return response.data;
}

export async function addPaymentCard(
    data: IAddPaymentCardPayload,
    consentId?: string
) {
    const response = await axios.post(`/payment-card`, {
        ...data,
        ...(consentId ? { consent_id: consentId } : {}),
    });
    return response.data;
}

export async function chargePaymentCard(data: IChargePaymentCardPayload) {
    const response = await axios.post(`/charge-payment-card`, data);
    return response.data;
}

export async function deletePaymentCards(cardIds: string[]) {
    const response = await axios.delete(`/payment-cards`, {
        data: { card_ids: cardIds },
    });
    return response.data;
}
